import { ActionIcon, Flex } from '@mantine/core';

import { IconX } from '@tabler/icons-react';
import { useDiscoveryContentDetailModalStyle } from '@/features/Discovery/discovery.style';
import { useModalControl } from '@/features/Discovery/Modal/DiscoveryContentDetailModal/hook/useHeaderMethod';

const DiscoveryModalHeader = () => {
  const { classes } = useDiscoveryContentDetailModalStyle();
  const { closeModal } = useModalControl();

  return (
    <div id={'header'} className={classes.headerContainer}>
      <Flex gap={12} justify={'space-between'} mb={24}>
        <ActionIcon
          size={36}
          className={classes.headerCloseButton}
          onClick={closeModal}
        >
          <IconX />
        </ActionIcon>
      </Flex>
    </div>
  );
};

export default DiscoveryModalHeader;
